import type { AssignmentsType } from 'core/types';

import initHistory from './init-history';
import isChanged from './is-changed';

export default (current: AssignmentsType, previous: AssignmentsType) => {
  const history: any[] = [...(current.history || [])];

  const isValid = previous?.updated && isChanged(current, previous);

  if (isValid) {
    history.push(initHistory(previous));
  }

  return history;
};
